import _ from 'lodash';
import { List } from 'antd';
import Button from '../../../views/StyledButton';
import React from 'react';

function stringify(sample) {
  switch (sample) {
    case true:
      return 'true';
      break;

    case false:
      return 'false';
      break;

    default:
      return `${sample}`;
  }
}

export default ({ state, actions }) => {
  let samples = [];
  try {
    samples = _(_.get(state, 'sample.rows', [])
      .map(({ sample }) => {
        if (!sample) {
          return false;
        }
        return Object.values(sample)[0];
      }))
      .uniq()
      .compact()
      .value();
  } catch (err) {
    console.log('error parsing sample: ', err);
  }

  return (<div>
    <h2>Sample Values:</h2>
    <List bordered size="small">
      {samples.map(sample => (
        <List.Item key={sample}>
          <Button type="link" block  align="left"  onClick={() => actions.setValue(stringify(sample))}>
            {stringify(sample)}
          </Button>
        </List.Item>
      ))}
    </List>
  </div>);
};
